// eslint-disable-next-line
/// <reference path="../../../tellent-mobile-shell/logic/global.d.ts" />

/**
 * Haptic feedback is implemented with Capacitor in `tellent-mobile-shell-logic`
 * and reached here through the native bridge, so the web bundles that ship this
 * library (Recruitee, Manage) stay free of Capacitor. A no-op wherever the
 * bridge is absent, which is every non-native host.
 */
export function triggerHapticImpact(): void {
  window.nativeMobileHr?.hapticImpact?.();
}
